<template>
  <detailed-list v-if="$route.params.type">
    <template slot="list">
      <queue v-if="$route.params.type === 'queue'" />
      <projects v-else class="h-full flex flex-col justify-between" />
    </template>
    <div class="relative h-full">
      <transition name="fade" mode="out-in">
        <router-view class="h-full" />
      </transition>
    </div>
  </detailed-list>
</template>

<script>
import DetailedList from "../Layout/DetailedList";
import Queue from "../Projects/Queue/Queue";
import Projects from "../Projects/Projects";
export default {
  components: { DetailedList, Queue, Projects },
};
</script>
